module.exports = __webpack_public_path__ + "img/logo-text_aurus.505a8b8c.svg";